"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTM = exports.pushToGTMDataLayer = exports.isDataLayerSet = exports.FormChannel = exports.NewsLetterAction = exports.FormActionEnum = exports.GTMEventEnum = void 0;
const Forms_1 = require("../Views/Partials/Components/Forms");
const Tile_1 = require("../Views/Partials/Components/Tile");
const constants_1 = require("../Views/Partials/Components/UmbracoFormsCustomComponents/constants");
var GTMEventEnum;
(function (GTMEventEnum) {
    GTMEventEnum["NewsLetter"] = "newsletterSignup";
    GTMEventEnum["Form"] = "form";
    GTMEventEnum["IPaper"] = "ipaper";
    GTMEventEnum["Print"] = "print";
    GTMEventEnum["Download"] = "download";
    GTMEventEnum["SocialLink"] = "socialLink";
    GTMEventEnum["Application"] = "application";
    GTMEventEnum["ExitLink"] = "exitLink";
    GTMEventEnum["Filter"] = "filter";
    GTMEventEnum["Search"] = "internal_search";
    GTMEventEnum["PMPLink"] = "CTAButtonClick";
    GTMEventEnum["Navigation"] = "navigation";
    GTMEventEnum["MegaMenu"] = "mega menu";
    GTMEventEnum["SearchResultLink"] = "internal_search_click";
    GTMEventEnum["ContactsListLocationFinderChange"] = "inputLocation";
    GTMEventEnum["ContactListItemClick"] = "contactListClick";
    GTMEventEnum["ContactDetailsDialClick"] = "clickToDial";
    GTMEventEnum["ContactDetailsCustomAttributesClick"] = "clickToCustomAttributes";
    GTMEventEnum["ContactFormOpen"] = "virtualPageView";
    GTMEventEnum["ContactFormLoadError"] = "formLoadError";
    GTMEventEnum["ProductListItemClick"] = "productListClick";
    GTMEventEnum["ProductPageTabClick"] = "productPageTabClick";
    GTMEventEnum["Social"] = "socialClick";
    GTMEventEnum["YoutubeVideo"] = "video";
    GTMEventEnum["FormRedirect"] = "contactUsFormServiceProcessRedirect";
})(GTMEventEnum || (exports.GTMEventEnum = GTMEventEnum = {}));
var FormActionEnum;
(function (FormActionEnum) {
    FormActionEnum["submit"] = "Click to Submit";
    FormActionEnum["success"] = "Success";
    FormActionEnum["errorBE"] = "Back-end error";
    FormActionEnum["errorFE"] = "Front-end validation error";
    FormActionEnum["abandon"] = "Abandon";
    FormActionEnum["viewCustomForm"] = "View Custom Form";
})(FormActionEnum || (exports.FormActionEnum = FormActionEnum = {}));
var NewsLetterAction;
(function (NewsLetterAction) {
    NewsLetterAction["open"] = "Click to Open Form";
    NewsLetterAction["success"] = "Success";
    NewsLetterAction["submit"] = "Click to Submit";
    NewsLetterAction["error"] = "Error";
    NewsLetterAction["abandon"] = "Abandon";
})(NewsLetterAction || (exports.NewsLetterAction = NewsLetterAction = {}));
exports.FormChannel = {
    [Forms_1.FormTypeEnum.Pardot]: 'Pardot',
    [Forms_1.FormTypeEnum.ServiceCloud]: 'Service Cloud',
    [Forms_1.FormTypeEnum.Distributors]: 'Distributors',
    [Forms_1.FormTypeEnum.DpsDistributors]: 'Custom for DPS Distributors',
    [Forms_1.FormTypeEnum.Custom]: 'Custom',
};
const tileListEventMapping = {
    [Tile_1.TileTypeEnum.SearchResults]: GTMEventEnum.SearchResultLink,
    [Tile_1.TileTypeEnum.Product]: GTMEventEnum.ProductListItemClick,
};
const isDataLayerSet = () => {
    return typeof dataLayer !== 'undefined';
};
exports.isDataLayerSet = isDataLayerSet;
const pushToGTMDataLayer = (obj) => {
    if (!(0, exports.isDataLayerSet)()) {
        return;
    }
    dataLayer.push(obj);
};
exports.pushToGTMDataLayer = pushToGTMDataLayer;
const formName = formType => formType === Forms_1.FormTypeEnum.Distributors
    ? exports.FormChannel[formType]
    : `Contact Us - ${exports.FormChannel[formType]}`;
const processUrlRedirection = (gtmItem, clickEvent, url) => {
    let callbackCalled = false;
    const callback = () => {
        if (callbackCalled)
            return;
        callbackCalled = true;
        window.location.href = url;
    };
    clickEvent.preventDefault();
    gtmItem.eventCallback = callback;
    setTimeout(callback, 1000);
};
exports.GTM = {
    /**
     * @param name     - link text
     * @param url      - link href
     * @param redirect - redirect, if link target != _blank
     */
    PMPButton: (name, url, redirect = false) => {
        let called = false;
        const gtmData = {
            buttonName: name,
            buttonURL: url,
            event: GTMEventEnum.PMPLink,
        };
        if (redirect) {
            const callBack = () => {
                if (!called) {
                    window.location.href = url;
                    called = true;
                }
            };
            gtmData.eventCallback = callBack;
            setTimeout(callBack, 1000);
        }
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    customForm: (currentForm) => {
        var _a;
        const customFormName = ((_a = currentForm.find('input[name="FormName"]')) === null || _a === void 0 ? void 0 : _a.val())
            ? currentForm.find('input[name="FormName"]').val()
            : 'Custom Form Name not set';
        let called = false;
        const callback = () => {
            if (!called) {
                called = true;
                currentForm.trigger('submit', [constants_1.formStatuses.processed]);
            }
        };
        exports.GTM.form.submit({ formType: Forms_1.FormTypeEnum.Custom }, customFormName, callback);
        setTimeout(callback, 1000);
    },
    setCustomFormName: (currentForm) => {
        var _a, _b;
        const customFormName = ((_a = currentForm.find('input[name="FormName"]')) === null || _a === void 0 ? void 0 : _a.val())
            ? currentForm.find('input[name="FormName"]').val()
            : 'Custom Form Name not set';
        const campaignName = ((_b = currentForm.find('input[data-alias="campaignName"]')) === null || _b === void 0 ? void 0 : _b.val())
            ? currentForm.find('input[data-alias="campaignName"]').val()
            : '(not set)';
        exports.GTM.form.setStatus({ formType: Forms_1.FormTypeEnum.Custom }, FormActionEnum.viewCustomForm, customFormName, null, null, campaignName);
    },
    download: (data, callBack) => {
        const gtmData = {
            event: GTMEventEnum.Download,
            [`${GTMEventEnum.Download}Name`]: data.name,
            [`${GTMEventEnum.Download}Path`]: data.path,
            [`${GTMEventEnum.Download}Page`]: data.page,
            [`${GTMEventEnum.Download}Type`]: data.type,
            [`${GTMEventEnum.Download}Category`]: data.category || 'other downloads',
            [`${GTMEventEnum.Download}Organization`]: data.organization || 'no organizations',
            segment: data.segment || 'no segments',
        };
        let called = false;
        if (callBack) {
            const innerCallBack = () => {
                if (!called) {
                    callBack();
                    called = true;
                }
            };
            gtmData.eventCallback = innerCallBack;
            setTimeout(innerCallBack, 1000);
        }
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    filter: (filterData) => {
        const gtmData = {
            NumberOfResults: filterData.numberOfResults,
            PageName: filterData.pageName,
            event: GTMEventEnum.Filter,
            filterCategory: filterData.filterCategory,
            filterOptions: filterData.filterOptions,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    form: {
        error: ({ formType }, isBeError, customFormName, errorField) => {
            const errorType = isBeError ? FormActionEnum.errorBE : FormActionEnum.errorFE;
            exports.GTM.form.setStatus({ formType }, errorType, customFormName, errorField);
        },
        setStatus: ({ formType }, actionType, customFormName, errorField, cb, campaignName) => {
            const isError = actionType === FormActionEnum.errorFE || actionType === FormActionEnum.errorBE;
            const actionLabel = isError ? 'Error' : actionType;
            const gtmData = {
                event: GTMEventEnum.Form,
                [`${GTMEventEnum.Form}Action`]: actionLabel,
                [`${GTMEventEnum.Form}Name`]: customFormName || formName(formType),
                [`${GTMEventEnum.Form}CampaignName`]: campaignName,
                [`${GTMEventEnum.Form}Type`]: exports.FormChannel[formType],
            };
            if (actionType === FormActionEnum.submit && cb) {
                gtmData.eventCallback = cb;
            }
            if (isError) {
                gtmData.ErrorType = actionType;
                !!errorField && (gtmData.ErrorField = errorField);
            }
            (0, exports.pushToGTMDataLayer)(gtmData);
        },
        abandon: ({ formType }, customFormName) => {
            exports.GTM.form.setStatus({ formType }, FormActionEnum.abandon, customFormName);
        },
        submit: ({ formType }, customFormName, cb) => {
            exports.GTM.form.setStatus({ formType }, FormActionEnum.submit, customFormName, null, cb);
        },
        success: ({ formType }, customFormName) => {
            exports.GTM.form.setStatus({ formType }, FormActionEnum.success, customFormName);
        },
        formRedirect: (item) => {
            if (!item.url) {
                return;
            }
            const gtmData = {
                event: GTMEventEnum.FormRedirect,
                formName: item.customFormName || formName(item.formType),
                linkUrl: item.url,
            };
            (0, exports.pushToGTMDataLayer)(gtmData);
        },
    },
    iPaper: (item) => {
        if (!item.name || !item.url) {
            return;
        }
        const gtmData = {
            event: GTMEventEnum.IPaper,
            [`${GTMEventEnum.IPaper}Name`]: item.name,
            [`${GTMEventEnum.IPaper}URL`]: item.url,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    newsletter: {
        error: (newsLetterData) => {
            exports.GTM.newsletter.setStatus(NewsLetterAction.error, newsLetterData);
        },
        setStatus: (actionType, newsLetterData) => {
            const gtmData = {
                event: GTMEventEnum.NewsLetter,
                newsletterName: newsLetterData.title,
                [`${GTMEventEnum.NewsLetter}`]: actionType,
                [`${GTMEventEnum.NewsLetter}Control`]: newsLetterData.control,
                [`${GTMEventEnum.NewsLetter}Text`]: newsLetterData.label,
            };
            if (actionType === NewsLetterAction.error) {
                gtmData.ErrorType = newsLetterData.errorType;
                if (newsLetterData.errorField) {
                    gtmData.ErrorField = newsLetterData.errorField;
                }
            }
            (0, exports.pushToGTMDataLayer)(gtmData);
        },
        subscribe: (newsLetterData) => {
            exports.GTM.newsletter.setStatus(NewsLetterAction.success, newsLetterData);
        },
        clickToSignup: (newsLetterData) => {
            exports.GTM.newsletter.setStatus(NewsLetterAction.submit, newsLetterData);
        },
        open: (newsLetterData) => {
            exports.GTM.newsletter.setStatus(NewsLetterAction.open, newsLetterData);
        },
        abandon: (newsLetterData) => {
            exports.GTM.newsletter.setStatus(NewsLetterAction.abandon, newsLetterData);
        },
    },
    menu: (clickEvent, item) => {
        const { menuLevel, url, parentNodePath, newWindow } = item;
        if (!parentNodePath || !menuLevel || !url) {
            return;
        }
        const menuPath = parentNodePath.split('/');
        const gtmItem = Object.assign({ event: GTMEventEnum.MegaMenu, targetUrl: url, menuLevel: menuLevel, menuItem: menuPath[0] }, (!!menuPath[1] && { subItem: menuPath[1] }));
        if (!newWindow) {
            processUrlRedirection(gtmItem, clickEvent, url);
        }
        (0, exports.pushToGTMDataLayer)(gtmItem);
    },
    zeroLevelMenu: (clickEvent, item) => {
        const { url, newWindow, caption, type, menuLevel, nodeName } = item;
        if (type !== 'zeroLevel' || !url) {
            return;
        }
        const gtmItem = {
            event: GTMEventEnum.MegaMenu,
            menuItem: nodeName ? nodeName : caption,
            targetUrl: url,
            menuLevel,
        };
        if (!newWindow) {
            processUrlRedirection(gtmItem, clickEvent, url);
        }
        (0, exports.pushToGTMDataLayer)(gtmItem);
    },
    search: (data) => {
        const gtmData = {
            event: GTMEventEnum.Search,
            search_id: data.sessionId,
            search_keyword_query: data.searchQuery || '',
            search_refinement: data.refinement,
            search_result_number: data.resultsCount,
            search_suggestion: data.suggestion || false,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    navigation: (data, callBack) => {
        const gtmData = {
            event: GTMEventEnum.Navigation,
            linkType: data.linkType,
            linkUrl: data.linkUrl,
        };
        if (callBack) {
            gtmData.eventCallback = callBack;
            setTimeout(callBack, 1000);
        }
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    tileListItem: (data, callBack) => {
        const gtmData = {
            event: tileListEventMapping[data.tileListType],
            clickUrl: data.clickUrl,
            linkPosition: data.linkPosition,
            linkPage: data.linkPage,
            NumberOfResults: data.numberOfResults,
        };
        let isCalled = false;
        if (callBack) {
            const innerCallBack = () => {
                if (!isCalled) {
                    callBack();
                    isCalled = true;
                }
            };
            gtmData.eventCallback = innerCallBack;
            setTimeout(innerCallBack, 1000);
        }
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    productTabs: (tabId) => {
        const gtmData = {
            event: GTMEventEnum.ProductPageTabClick,
            productPageTab: tabId,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    socialLinks: (data) => {
        const gtmData = {
            event: GTMEventEnum.Social,
            socialChannel: data.channel,
            socialLink: data.link,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactsListLocationFinder: (fieldValue) => {
        const gtmData = {
            event: GTMEventEnum.ContactsListLocationFinderChange,
            input: fieldValue,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactsListItem: (companyName) => {
        const gtmData = {
            event: GTMEventEnum.ContactListItemClick,
            companyName: companyName,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactsListFilter: (filterData) => {
        const gtmData = {
            event: GTMEventEnum.Filter,
            filterCategory: filterData.filterCategory,
            filterOptions: filterData.filterOptions,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactDetailsDialClick: (companyName) => {
        const gtmData = {
            event: GTMEventEnum.ContactDetailsDialClick,
            companyName,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactDetailsCustomAttributesClick: (companyName) => {
        const gtmData = {
            event: GTMEventEnum.ContactDetailsCustomAttributesClick,
            companyName,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactFormOpen: (contactFormData) => {
        const gtmData = Object.assign({ event: GTMEventEnum.ContactFormOpen }, contactFormData);
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactFormLoadError: (companyName) => {
        const gtmData = {
            event: GTMEventEnum.ContactFormLoadError,
            companyName,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    webAnalytics: {
        pushCommonContext: (commonData) => {
            const commonContext = {
                language: commonData.language || '',
                user_id: commonData.user_id || '',
            };
            (0, exports.pushToGTMDataLayer)({ commonContext });
        },
        pushPageContext: (pageData) => {
            const pageContext = {
                business_unit: pageData.business_unit || [],
                category: pageData.category || [],
                description: pageData.description || '',
                image_link: pageData.image_link || '',
                market: pageData.market || [],
                name: pageData.name || '',
                type: pageData.type || '',
                unique_id: pageData.unique_id || '',
                url: pageData.url || '',
            };
            (0, exports.pushToGTMDataLayer)({ pageContext });
        },
        pushProductContext: (_productData) => {
            const productContext = {};
            (0, exports.pushToGTMDataLayer)({ productContext });
        },
    },
    iframeYoutubeVideo: (data) => {
        const gtmData = {
            event: GTMEventEnum.YoutubeVideo,
            videoName: data.videoTitle,
            videoAction: data.videoStatus,
            videoProgress: data.videoProgress,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    login: (userId) => {
        (0, exports.pushToGTMDataLayer)({ analytics_user_id: userId });
    },
};
